import * as React from "react";

export function useIsMobile(breakpoint: number = 768): boolean {
  const query = `(max-width: ${breakpoint}px)`;

  const [isMobile, setIsMobile] = React.useState<boolean>(
    () => typeof window !== `undefined` && window.matchMedia(query).matches
  );

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener(`change`, onChange);
    return () => mql.removeEventListener(`change`, onChange);
    // eslint-disable-next-line
  }, [breakpoint]);

  return isMobile;
}
